/* pantallas-alumno (B): EL NUMERO DE RESUMEN (piezas nuevas de la parte 2; tambien los cuadros del
   resumen de Flashcards de la parte 1, regla fija 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   La tarjeta del Panel (fondo #141414, borde #222222, radio 18) con relleno 16 18 (12 en el celular):
   la etiqueta de 13 px #9A9A9A y el numero de 30 bold (22 en el celular) con numeros tabulares.
   `FilaDeResumen`: tres por fila, siempre. `colorDelNumero` pinta el numero de otro color si el
   diseno lo pide (por ejemplo, el verde de "Known"). */
import React from 'react';

export default function NumeroDeResumen({ etiqueta, numero, colorDelNumero, testid, className = '' }) {
  return (
    <div data-testid={testid}
      className={`min-w-0 rounded-[18px] border border-[#222222] bg-[#141414] p-3 md:py-4 md:px-[18px] ${className}`.trim()}>
      <p data-parte="etiqueta" className="text-[13px] leading-[18px] text-[#9A9A9A] break-words">{etiqueta}</p>
      <p data-parte="numero" className="mt-1 text-[22px] md:text-[30px] leading-tight font-bold tabular-nums text-[#F4F4F3]"
        style={colorDelNumero ? { color: colorDelNumero } : undefined}>{numero}</p>
    </div>
  );
}

export function FilaDeResumen({ children, testid, className = '' }) {
  return <div data-testid={testid} className={`grid grid-cols-3 gap-2 md:gap-4 ${className}`.trim()}>{children}</div>;
}
